import area from "@turf/area"
import { downloadData } from "aws-amplify/storage"
import { GeoJsonObject } from "geojson"
import useSWR from "swr"

import {
  getCombinedSoftenedGeoJsonPath,
} from "@/config/backend"
import { env } from "@/env.setup"
import { TODO } from "@/types/utility"
import { useCurrentBuildVersion } from "./use-current-build-version"

const COUNTY_GEOJSON_KEY = "COUNTY_GEOJSON_KEY"

export function useCountyGeojson() {
  const { data: version } = useCurrentBuildVersion()
  return useSWR(version === undefined ? null : [COUNTY_GEOJSON_KEY, version], () => {
    if (!version) {
      console.warn("[useCountyGeojson]: No version provided, falling back to local geojson.");
      return getFromServerFallback();
    }
    return getGeojson(version)
  }, {
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
  })
}

async function getGeojson(version: string | null | undefined): Promise<GeoJsonObject> {
  const probablyGeojson = await getFromServer(version ?? undefined);

  probablyGeojson.features.sort((a: TODO, b: TODO) => {
    const areaA = area(a)
    const areaB = area(b)
    return areaB - areaA
  })

  return probablyGeojson as GeoJsonObject
}

async function getFromServer(version?: string) {
  try {
    if (!version) throw new Error('No version provided')
    const path = getCombinedSoftenedGeoJsonPath(version)
    const { body } = await downloadData({ path, options: { bucket: { bucketName: env.VITE_AWS_S3_DOWNLOAD_BUCKET_NAME, region: "us-east-2" }, } }).result

    const probablyGeojsonString = await body.text()
    const probablyGeojson = JSON.parse(probablyGeojsonString)
    return probablyGeojson
  } catch (e) {
    return getFromServerFallback()
  }
}

async function getFromServerFallback(): Promise<TODO> {
    const locations = await import("@/assets/combined_softened.json")
    return locations.default
}
